<script>
	import { createEventDispatcher } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { TipoEvento } from '../utils';
	import TBox from './templates/TBox.svelte';

	const dispatch = createEventDispatcher();
	const salvarConsentimentoUsurioTermosEdital = () => {
		
		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			mensagem: 'Aguarde, redirecionando ...',
			valor: true
		});
		
		localStorage.setItem('CETREINA_CONF_CONS', JSON.stringify({
			data_consentimento: new Date().toLocaleString()
		}));

		setTimeout( () => replace('#/'), 2000);
	}
</script>

<TBox 
	titulo="Aviso" 
	subtitulo="Leia atentamente o edital" 
	largura="6" 
	deslocamento="3" 
	correcaoY="-13px"
	icone="aviso">

	<div class="p-4 has-text-centered">
		<p class="is-size-4">Ao acessar o sistema você concorda com os</p>
		<br>
		<strong>TERMOS E REGRAS DO EDITAL</strong>.
		<br><br>

		<a href="https://drive.google.com/file/d/1pguXXw_gPk44NEHrn3prNoN9F0SOZz7S/view?usp=sharing" target="_blank">EDITAL ID</a> |
		<a href="https://drive.google.com/file/d/1ZJnGG3nS8-1z3MJzTEraOz6NM6NknhEG/view?usp=sharing" target="_blank">EDITAL MON</a> |
		<a href="https://drive.google.com/file/d/1-TV0X3viZwbIIqTv5Fkw-Q47AlSOq59j/view?usp=sharing" target="_blank">EDITAL EIC</a>

		<br>

		<span>EDITAL PRODOCÊNCIA:
			<a href="https://drive.google.com/file/d/10ea7eVE5fMu9ZoOLrTZAopgkcn3EH7PK/view?usp=sharing" target="_blank">2021</a> |
			<a href="https://drive.google.com/file/d/1dO6gRIcTs0uEDby_ipfYKBb1nKIAeys1/view?usp=sharing" target="_blank">2022</a>
		</span>

		<hr>

		<small class="is-size-6">Clique no link do edital apropriado acima para leitura.</small>
		<br><br>
		<button class="button is-primary is-size-4" on:click|preventDefault={salvarConsentimentoUsurioTermosEdital}>Clique aqui para continuar</button>
	</div>
</TBox>